<template>
  <div v-if="statusMap[status]" class="kyc-tag">
    <sb-badge :variation="statusMap[status].type" size="extra-small">
      {{ statusMap[status].title }}
    </sb-badge>
  </div>
</template>
<script>

import KYCStatus from '@/enums/modules/setup/KYCStatus'

export default {
  name: 'KYCTag',
  props: {
    status: {
      type: Number,
      required: true
    }
  },
  data: () => {
    return {
      statusMap: {
        [KYCStatus.Pending]: {
          title: 'In Progress',
          type: 'warning'
        },
        [KYCStatus.Completed]: {
          title: 'Under Review',
          type: 'primary'
        },
        [KYCStatus.Expired]: {
          title: 'Expired',
          type: 'error'
        },
        [KYCStatus.Failed]: {
          title: 'Insufficient Info',
          type: 'error'
        },
        [KYCStatus.NeedsReview]: {
          title: 'Document(s) Required',
          type: 'error'
        },
        [KYCStatus.Approved]: {
          title: 'Approved',
          type: 'success'
        },
        [KYCStatus.Declined]: {
          title: 'Declined',
          type: 'error'
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.kyc-tag {
    margin-left: 1em;
}
</style>
